import moment from "moment";
import { CreditReportPersonalData } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

interface PersonalDataProps {
  personal_data?: CreditReportPersonalData;
  isNoHit: boolean;
}

export const PersonalData = ({ personal_data, isNoHit }: PersonalDataProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Response from Equifax" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Response from Equifax" maxWidth="none">
      <div className="flex w-full flex-row flex-wrap">
        <div className="flex w-full flex-col gap-3">
          <Row title="Full name" value={personal_data?.full_name} />
          <Row title="SSN" value={personal_data?.ssn} />
          <Row
            title="File pulled"
            value={
              personal_data?.file_pulled &&
              moment(personal_data.file_pulled).isValid() &&
              moment(personal_data.file_pulled).format("MMM DD, YYYY")
            }
          />
          <Row
            title="User ID/Member number"
            value={personal_data?.customer_number}
          />
          <Row
            title="Date of birth"
            value={
              personal_data?.dob &&
              moment(personal_data.dob).isValid() &&
              moment(personal_data.dob).format("MMM DD, YYYY")
            }
          />
        </div>
      </div>
    </Section>
  );
};
